<template>
    <b-modal
        ref="documentPreviewModal"
        cancel-variant="outline-secondary"
        size="xl"
        :ok-title="$t('Component(Button):close')"
        scrollable
        ok-only
        centered
        :title="file ? file.file.name : ''"
    >
        <Overlay :show="showOverlay">
            <object v-if="downloaded" :data="url" :type="file.file.mime" width="100%" :height="height">
                unable to display document
            </object>
        </Overlay>
    </b-modal>
</template>

<script>
import { BModal, BEmbed } from 'bootstrap-vue'
import {ProductApi} from "@core/api";
import Overlay from "@core/components/common/Overlay";

export default {
    components: {BModal, BEmbed, Overlay},
    props: {
        request: {
            default: null
        },
        requestId: {
            default: null,
        },
        file: {
            type: Object,
            default() {
                return {
                    id: null,
                    file: {
                        mime: 'application/pdf',
                        name: ''
                    }
                };
            }
        }
    },
    data() {
        return {
            showOverlay: true,
            downloaded: false,
            url: null,
            height: this.calculateHeight()
        }
    },
    mounted() {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(document.body);
    },
    methods: {
        onResize() {
            this.height = this.calculateHeight();
        },
        show() {
            this.$refs.documentPreviewModal.show();
            this.download();
        },
        download() {
            if (!this.file || !this.file.id) {
                return false;
            }
            let requestId = this.requestId || this.request.id || null;

            if (!requestId) {
                return false;
            }

            ProductApi
                .downloadRepliedDocument(requestId, this.file.id)
                .then(response => {
                    this.url = URL.createObjectURL(new Blob([response.data], {type: this.file.file.mime}));
                    this.downloaded = true;
                    this.showOverlay = false;
                })
        },
        calculateHeight() {
            return (document.body.offsetHeight - 200) + 'px;';
        }
    },
}
</script>
